import { useImageAnnotatorContext } from "@msuite/image-annotator";
import { Fragment } from "react";

export function PolygonAnnotationPreview() {
	/** Context */
	const context = useImageAnnotatorContext();

	/** Computed */
	const combinedScale = context.baseScale * context.scale;

	/** Guard */
	if (context.controller.tool !== "polygon") return null;

	/** Render */
	return (
		<Fragment>
			<polyline
				points={[...context.controller.polygonPoints].map((p) => `${p.x},${p.y}`).join(" ")}
				stroke={context.controller.polygonDefault.strokeColor}
				strokeWidth={(context.controller.polygonDefault.strokeWidth || 3) / context.baseScale}
				fill="none"
				strokeDasharray={`${8 / context.baseScale} ${4 / context.baseScale}`}
			/>
			{context.controller.polygonPoints.map((p, i) => (
				<circle
					key={i}
					cx={p.x}
					cy={p.y}
					r={6 / combinedScale}
					fill={i === 0 ? "var(--color-yellow-500)" : context.controller.polygonDefault.strokeColor}
				/>
			))}
		</Fragment>
	);
}
